<script setup lang="ts">
import { ref } from 'vue';
import AppModal from '@/components/v2/AppModal.vue';

type ResolveFunction = (value: boolean) => void;

const isVisible = ref(false);
const resolveCallback = ref<ResolveFunction | null>(null);
const displayMessage = ref<string>('Are you sure you want to continue?');

const showConfirm = (message: string): Promise<boolean> => {
  return new Promise((resolve) => {
    displayMessage.value = message;
    resolveCallback.value = resolve;
    isVisible.value = true;
  });
};

const confirm = (): void => {
  isVisible.value = false;
  if (resolveCallback.value) resolveCallback.value(true);
};

const cancel = (): void => {
  isVisible.value = false;
  if (resolveCallback.value) resolveCallback.value(false);
};

defineExpose({ showConfirm });
</script>

<template>
  <AppModal
    :show="isVisible"
    :handle-cancel="() => cancel()"
    :handle-action="() => confirm()"
    action-button-label="Confirm">
    <template #content>
      <div class="tw:mt-1 tw:flex tw:w-full">
        <span class="tw:mx-auto">{{ displayMessage }}</span>
      </div>
    </template>
  </AppModal>
</template>
